<gd-form-message [message]="error?.message" [className]="'negative'" [isVisible]="isVisible" (dismiss)="onDismiss()">
</gd-form-message>
